export default Object.freeze({


    SAVE: "Record Saved Successfully",
    UPDATE: "Record Updated Successfully :)",
    DELETE: "Record Deleted Successfully",
    VALIDATE: "validation error occured.Please check the required field values!."


});


// WEBPACK FOOTER //
// ./src/constant.js